/**
@IMPORTANT : this file pertains to products on the main nav-bar 
**/

var othersCatAdded = false; 

function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

function createDiffGensOnUI(dropdownCatUlTag, addModels, organizedGens, formatHyperLink, mobileView=false) {
    /**
    @description: Creates HTML structure needed 2 create sub-dropdown on products tab. 
    <ul> // PROVIDED IN nav_bar.products_dropdown_menu 
        <li> // liGenTag
            <a> // genContainerAnchorTag
                <span>||Gen||</span> // genNameSpanTag
                <span class='caret'></span>
            </a>
            <ul> // modelsContainerUlTag
                <li>
                    <a>||model||</a>
                </li>
            </ul>
        </li>
    </ul>
    @param  {htmlEl}        dropdownCatUlTag: ul-tag to append categories and sub-dropmenu (if addModels == true)
    @param  {boolean}       addModels: Condition for adding sub-dropdown to gens 
    @param  {Object[category, Array[Object]]} organizedGens: Categoriezed dataset 
    @param  {boolean}       formatHyperLink: Condition for formating hyperlink when usr onClicks anchor tag 
    **/
    let gen_id_counter = 1, 
        brandName      = dropdownCatUlTag.id.split('-')[0] // taken from ul-tag, e.g. #dell-dropdown => dell-dropdown 
    ; 
    
    for (const [gen, models] of Object.entries(organizedGens)) { // itr gens: Object[Gen, Array[Object]]
        let htmlDict = htmlDict_4ProductsGenAndModels(); 
        if (models === null || models === undefined) continue;
        if (models.every(function(model) {if (model.numOfAvailProducts === 0) return true})) continue;

        renderWideDropdown_WhenNotin(mobileView); 
        setAttr_2liGenTag(htmlDict, brandName, gen_id_counter, gen); 
        setName_2genAndAppend_2liGenTag(gen, htmlDict, mobileView); 
        if (addModels) { // used 4 creating ul that will contain gens 
            addModelsUlTag_2liGenTag(htmlDict, mobileView);
 
        } else {
            setHref_2availGen(organizedGens, gen, htmlDict.genContainerAnchorTag); // NOT 4 gens  
        }

        dropdownCatUlTag.append(htmlDict.liGenTag); 
        gen_id_counter += 1; 
    } 

    if (addModels) createModelsDropdown(organizedGens, brandName, formatHyperLink); // creates li 4 modelsContainerUlTag 
    if(htmlEl('#WorkStations_server_1') ) { 
        htmlEl('#WorkStations_gen_1_liGenMarker').querySelector('span').innerText = testRackOrTower('#WorkStations_gen_1_liGenMarker'); 
        htmlEl('#WorkStations_server_1').style.display = 'contents'; 
    }
    if(htmlEl('#WorkStations_server_2')) { 
        htmlEl('#WorkStations_gen_2_liGenMarker').querySelector('span').innerText = testRackOrTower('#WorkStations_gen_2_liGenMarker'); 
        htmlEl('#WorkStations_server_2').style.display = 'contents'; 
    }
}
// function createDiffGensOnUI

function testRackOrTower(genTag) {
    if (htmlEl(genTag).querySelector('span').innerText.includes('Rack-Mount')){
        return ('Rack-Mount Workstations');
    } else if (htmlEl(genTag).querySelector('span').innerText.includes('Tower')) {
        return ('Tower Workstations');
    }
}

function htmlDict_4ProductsGenAndModels() {
    /**
    @description: 
    **/
    let htmlDict = {
        genContainerAnchorTag   : createHtmlEl('a'), 
        genNameSpanTag          : createHtmlEl('span'),
        caretIconSpanTag        : createHtmlEl('span'),
        modelsContainerUlTag    : createHtmlEl('ul'), 
        liGenTag                : createHtmlEl('li')
    }; 

    return htmlDict; 
}



function renderWideDropdown_WhenNotin(mobileView) {
    /**
    @description: 
    @param {} 
    **/
    if (!mobileView) {
        productsTabEventHandler();      // handles hovering events 
        setDropdownMenuDim();           // set dropdown 2 'wide menu style'
        renderProductsDropdownMenu();   // display flex dropdown menu 
        renderGensAndModelsListing();   // display contents gens and models 
        rmUnwantedLiTags();             // rm old li tags 4 desktop, laptops, view all cats
        rmCaretIcon();                  // rm caret icons 
        underlineProductCats();         // underlines products cats 
   //     stylizeProductCatLbl();         // stylizes products cats 
     //   addOthersCat(); 
        Array.from(document.getElementsByClassName('otherProd')).forEach(function (otherProd) {
            otherProd.setAttribute('style', 'color: white !important; font-size: 20px !important; padding: 5px 15px 5px 25px !important; line-height: 20px !important;');
        });
    }
    
}
// function renderWideDropdown_WhenNotin 



function productsTabEventHandler() {
    /**
    @description: handles hovering events when mouse enters 'Products' tab and when mouse leaves 'Products' tab 
    **/
    htmlEl('.navbarProductsTab').addEventListener('mouseenter' , function () {
        htmlEl('#productDropdownMenu').style.display    = 'flex'; 
        htmlEl('#productDropdownMenu').style.flexFlow   = 'column wrap'; 
        htmlEl('#productDropdownMenu').classList.add('products_dropdown_menu_desktop_view');
        // if (htmlEl('#CTOHeader') && htmlEl('#CTOHeaderbackground')){
        //     htmlEl('#CTOHeader').style.display = 'none';
        //     htmlEl('#CTOHeaderbackground').style.display = 'none';
        // } 
    }); 

    htmlEl('.navbarProductsTab').addEventListener('mouseleave' , function () {
        htmlEl('#productDropdownMenu').style.display    = 'none'; 
        htmlEl('#productDropdownMenu').style.flexFlow   = 'column wrap'; 
        htmlEl('#productDropdownMenu').classList.add('products_dropdown_menu_desktop_view'); 
        // if (htmlEl('#CTOHeader')){
        //     htmlEl('#CTOHeader').style.display = 'flex';
        //     htmlEl('#CTOHeaderbackground').style.display = 'flex';
        // } 
    }); 
}



function setDropdownMenuDim() {
    /**
    @description: sets the dim of the dropdown list 
    **/
    htmlEl('#productDropdownMenu').classList.add('productDropdownMenu_4desktopView');
}
// function setDropdownMenuDim 



function renderProductsDropdownMenu() {
    /**
    @description: 
    **/
    htmlEl('#dell-dropdown').addEventListener('mouseenter' , function () {
        htmlEl('#productDropdownMenu').style.display = 'flex'; 
    }); 
}
// function renderProductsDropdownMenu



function renderGensAndModelsListing() {
    /**
    @description: 
    **/
    htmlEl('#productDropdownMenu').querySelectorAll('ul').forEach(function(ulDropdown) {
        ulDropdown.style.display = 'contents' ; 
    }); 
}
// function renderGensAndModelsListing 



function rmUnwantedLiTags() {
    /**
    @description: 
    **/
    htmlEl('#productDropdownMenu').querySelectorAll('li[id^="product_cat_"]').forEach(function(liDropdown) {
        liDropdown.remove()
    }); 
}
// function rmUnwantedLiTags 



function rmCaretIcon() {
    /**
    @description: 
    **/
    htmlEl('#productDropdownMenu').querySelectorAll('span[id$="_caret_cat"]').forEach(function(caretIcon) {
        caretIcon.remove()
    }); 
}
// function rmCaretIcon 



function underlineProductCats() {
    /**
    @description: 
    **/
    htmlEl('#productDropdownMenu').querySelectorAll('a[class*="product_cat"]').forEach(function(catAnchorTag) {
        collectionName = catAnchorTag.innerText.trim().toLowerCase();
        collectionName = collectionName.replace(/ /g, '-');
        if (collectionName == 'dell-servers') collectionName = 'servers-dell';
        if (collectionName == 'hp-servers') collectionName = 'servers-hp';
        if (collectionName == 'components') collectionName = 'parts';

        catAnchorTag.style.borderBottom = '1px solid white'; 


        if (collectionName === 'other-products'){
            catAnchorTag.href = '/collections/';
        }
        else{
            catAnchorTag.href = '/collections/' + capitalizeFirstLetter(collectionName);
        }

        if(collectionName === 'servers-dell' ){
            catAnchorTag.href = '/collections/configure-to-order-servers?br=dell';
        }
        if(collectionName === 'servers-hp' ){
            catAnchorTag.href = '/collections/configure-to-order-servers?br=hp';
        }

        if(collectionName === 'servers-cisco' ){
            catAnchorTag.href = '/collections/configure-to-order-servers?br=cisco';
        }
        if(collectionName === 'servers-supermicro' ){
            catAnchorTag.href = '/collections/configure-to-order-servers?br=supermicro';
        }
        if(collectionName === 'workstations' ){
            catAnchorTag.href = '/collections/configure-to-order-servers?br=precision';
        }
        

    }); 
}
// function underlineProductCats



function stylizeProductCatLbl() {
    /**
    @description: 
    **/
    htmlEl('#productDropdownMenu').querySelectorAll('span[class*="product_cat_lbl"]').forEach(function(productLbl) {
        productLbl.style.color          = '#79cdcd'; 
        productLbl.style.fontSize       = '19px !important;'; 
        productLbl.style.letterSpacing  = '3px'; 
        productLbl.style.fontWeight     = '700'; 
    });
}
// function stylizeProductCatLbl 



function addOthersCat() {
    /**
    @description: 
    **/
    if (!othersCatAdded) {
        let htmlDict = htmlDict_4otherProductsColCat();  
        
        setOtherProductsCatAttr(htmlDict); 
        assignTxt_2otherProductCol(htmlDict); 
        assembleHtmlStructure_2otherCat(htmlDict); 
        htmlEl('#productDropdownMenu').append(htmlDict.othersLiTag); 

        othersCatAdded = true; 
    }
}
// function addOthersCat 



function htmlDict_4otherProductsColCat() {
    /**
    @description: 
    @return htmlDict 
    **/
    let htmlDict = {
        othersLiTag         : createHtmlEl('li'), 
        productCatContainer : createHtmlEl('a'), 
     //   productCatLbl       : createHtmlEl('span'), 
        desktopAnchorTag    : createHtmlEl('a'), 
        laptopAnchorTag     : createHtmlEl('a'), 
        networkingAnchorTag : createHtmlEl('a'), 
        monitorsAnchorTag   : createHtmlEl('a'),
    };  

    return htmlDict; 
}






function setOtherProductsCatAttr(htmlDict) {
    /**
    @description: 
    @param {} 
    **/
    setHtmlAttr(htmlDict.productCatContainer, 'class', 'product_cat');
   // setHtmlAttr(htmlDict.productCatLbl,       'class', 'product_cat_lbl');
    setHtmlAttr(htmlDict.othersLiTag,         'class', 'dropdown-submenu animate__animated animate__fadeIn'); 
    setHtmlAttr(htmlDict.desktopAnchorTag,    'href', '/collections/desktops'); 
    setHtmlAttr(htmlDict.laptopAnchorTag,     'href', '/collections/laptops'); 
    setHtmlAttr(htmlDict.networkingAnchorTag, 'href', '/collections/networking'); 
    setHtmlAttr(htmlDict.monitorsAnchorTag,   'href', '/collections/monitors');
   // setHtmlAttr(htmlDict.desktopAnchorTag,    'class', 'other_product_desktops otherProd'); 
    setHtmlAttr(htmlDict.laptopAnchorTag,     'class', 'other_product_laptops otherProd'); 
    setHtmlAttr(htmlDict.networkingAnchorTag, 'class', 'other_product_networking otherProd'); 
    setHtmlAttr(htmlDict.monitorsAnchorTag,   'class', 'other_product_monitors otherProd ');
    //setting styles for mobile view
    setHtmlAttr(htmlDict.monitorsAnchorTag,   'style', 'color:#9d9d9d!important; font-size:20px!important; padding: 5px 15px 5px 25px !important; line-height: 20px !important;');
    setHtmlAttr(htmlDict.networkingAnchorTag, 'style', 'color:#9d9d9d!important; font-size:20px!important; padding: 5px 15px 5px 25px !important; line-height: 20px !important; ');
    setHtmlAttr(htmlDict.laptopAnchorTag,     'style', 'color:#9d9d9d!important; font-size:20px!important; padding: 5px 15px 5px 25px !important; line-height: 20px !important; ');
    setHtmlAttr(htmlDict.desktopAnchorTag,    'style', 'color:#9d9d9d!important; font-size:20px!important;  padding: 5px 15px 5px 25px !important; line-height: 20px !important;');
//    setHtmlAttr(htmlDict.productCatLbl,       'style', 'color:white!important; ');

    //I do not like this. 
    setHtmlAttr(htmlDict.productCatContainer, 'style', 'color:#777!important; ')

}
// function setOtherProductsCatAttr 



function assignTxt_2otherProductCol(htmlDict) {
    /**
    @description: 
    @param {} 
    **/
   // htmlDict.productCatLbl.innerText         = 'Other Products'; 
    htmlDict.desktopAnchorTag.innerText      = 'Desktops'; 
    htmlDict.laptopAnchorTag.innerText       = 'Laptops'; 
    htmlDict.networkingAnchorTag.innerText   = 'Networking'; 
    htmlDict.monitorsAnchorTag.innerText     = 'Monitors';
}
// function assignTxt_2otherProductCol 



function assembleHtmlStructure_2otherCat(htmlDict) {
    /**
    @description: 
    @param {} 
    **/
 //   htmlDict.productCatContainer.append(htmlDict.productCatLbl); 
    htmlDict.othersLiTag.append(htmlDict.productCatContainer); 
    htmlDict.othersLiTag.append(htmlDict.desktopAnchorTag); 
    htmlDict.othersLiTag.append(htmlDict.laptopAnchorTag); 
    htmlDict.othersLiTag.append(htmlDict.monitorsAnchorTag);
    htmlDict.othersLiTag.append(htmlDict.networkingAnchorTag); 
}
// function assembleHtmlStructure_2otherCat 



function setAttr_2liGenTag(htmlDict, brandName, gen_id_counter, gen) {
    /**
    @description: provides the appropriate attrs to the html strcuture 4 listing gen of products 
    @param {} 
    **/
    if (gen){
        gen = gen.trim();
        if (gen.includes(' ')) {
            gen = gen.replace(/ /g, '-');
        }   
        if (gen.includes('Gen')) {
            gen = gen.replace(/Gen/g, 'Generation');
        }

    } else {
        gen = '';
    }

    setHtmlAttr(htmlDict.genContainerAnchorTag,  'class',    'dropdown-toggle'); 
    setHtmlAttr(htmlDict.liGenTag,               'id',       `${brandName}_gen_${gen_id_counter}_liGenMarker`); 
    setHtmlAttr(htmlDict.liGenTag,               'class',    'dropdown-submenu'); 
    setHtmlAttr(htmlDict.caretIconSpanTag,       'class',    'caret'); 
    setHtmlAttr(htmlDict.modelsContainerUlTag,   'id',       `${brandName}_server_${gen_id_counter}`); 
    setHtmlAttr(htmlDict.genContainerAnchorTag,  'href', `/collections/${capitalizeFirstLetter(brandName)}-${gen}`); 
    setHtmlAttr(htmlDict.modelsContainerUlTag,   'class',    'dropdown-menu animate__animated animate__fadeIn'); 
}
// function setAttr_2liGenTag 



function setName_2genAndAppend_2liGenTag(gen, htmlDict, mobileView) {
    /** 
    @description: 
    @param {} 
    **/

    htmlDict.genNameSpanTag.innerHTML = gen; 
    if (!mobileView) {
        htmlDict.genNameSpanTag.style.cursor = 'default'; 
        htmlDict.genNameSpanTag.style.fontWeight = '550'; 
        htmlDict.genNameSpanTag.style.letterSpacing = '1px'; 
        htmlDict.genNameSpanTag.style.color = '#79cdcd'; 
        htmlDict.genNameSpanTag.style.marginLeft = '5px';
        setHtmlAttr(htmlDict.genNameSpanTag, 'class', 'product_gen_title_txt')
    }
    htmlDict.genContainerAnchorTag.append(htmlDict.genNameSpanTag);  
    htmlDict.liGenTag.append(htmlDict.genContainerAnchorTag); 
}
// function setName_2genAndAppend_2liGenTag 



function addModelsUlTag_2liGenTag(htmlDict, mobileView) {
    /**
    @description: 
    @param {} 
    **/
    if (mobileView) htmlDict.genContainerAnchorTag.append(htmlDict.caretIconSpanTag); 
    htmlDict.liGenTag.append(htmlDict.modelsContainerUlTag); 
}
// function addModelsUlTag_2liGenTag 



function createModelsDropdown(organizedGens, brandName, formatHyperLink) {
    /**
    @description: handles creating models li tags 4 modelsContainerUlTag
    @param  {Object[gen, Array[Object]]} organizedGens: 
    @param  {string}    brandName: Brand name of category, e.g. Dell, HP, Cisco, etc. 
    @param  {boolean}   formatHyperLink: Condition for formating hyperlink when usr onClicks anchor tag 
    **/
    let gen_id_counter = 1; 

    for (const [gen, models] of Object.entries(organizedGens)) {
        if(models === null || models === undefined) continue;
        if (models.every(function(model) {
            if (model.numOfAvailProducts === 0) return true
        })) continue; 

        renderServerProducts(`#${brandName}_server_${gen_id_counter}`, models, formatHyperLink, "CreareModelsDropdown"); 
        gen_id_counter += 1; 
    } 
    gen_id_counter = 1; 
}
// function createModelsDropdown
async function getContentfulCollectionUtilForTempCache(collectionHandle){


    const contentful = `https://apiapi.ombligo.com/n_contentful/collection/${collectionHandle}`;


    try {
        const response = await fetch(contentful);
        const data = await response.json();
        return data;
    } catch (error) {
        console.log('Likely No Data:', error);
    }
}
// console.log("Defining debouncePreload function");
// const debouncePreload = (func, delay) => {
//     return function (...args) {
//         clearTimeout(debounceTimeout);
//         debounceTimeout = setTimeout(() => func.apply(this, args), delay);
//     };
// };
var debounceTimeout = debounceTimeout || null;
var debouncePreload = debouncePreload || function(func, delay) {
    return function (...args) {
        clearTimeout(debounceTimeout);
        debounceTimeout = setTimeout(() => func.apply(this, args), delay);
    };
};

async function preloadContentfulData(href)  {
    const CACHE_KEY = 'contentfulCollectionCache';
    const CACHE_EXPIRATION = 24 * 60 * 60 * 1000; 

    const cachedData = localStorage.getItem(CACHE_KEY);
    const cacheTimestamp = localStorage.getItem(`${CACHE_KEY}_timestamp`);

    if (!cachedData || (cacheTimestamp && (Date.now() - cacheTimestamp) > CACHE_EXPIRATION)) {
        try {
            const data = await getContentfulCollectionUtilForTempCache(href);
            localStorage.setItem(CACHE_KEY, JSON.stringify(data.items[0].fields));
            localStorage.setItem(`${CACHE_KEY}_timestamp`, Date.now());
        } catch (error) {
            console.error('Error caching Contentful data:', error);
        }
    } else {
    }
};

function renderServerProducts(id_tag, models, formatHyperLink, parentCaller) { 
    /**
    @description: Provides all the diff models on sub-drropdown usr can choose from a specific generation of a given collection.
    The rendering of options is dynmaically done through the avail collection on shopify's collections tab  
    @param  {string}        id_tag: The id value assigned to `ul` tags containing the available products 
    @param  {Array[Object]} models: A list of collection obj  
    @param  {boolean}       formatHyperLink: Condition for formating hyperlink when usr onClicks anchor tag 
    **/
    let ulTag = htmlEl(id_tag); 

    for (let [idx, collectionObj] of Object.entries(models)) { // itr(models:Array[Object], idx) 

        let liTag       = createHtmlEl('li'), // creates li tag 
            anchorTag   = createHtmlEl('a'), // creates anchor tag 
            hrefLink    = formatHyperLink ? _formatHyperLink(collectionObj.href.toLowerCase()) : collectionObj.href.toLowerCase(); 
        ; 
        
        if (collectionObj.model === 'XC630' && hrefLink === 'dell-xc'){
            hrefLink = 'dell-xc630';
        }
        if (collectionObj.model === 'Generation' || collectionObj.model === 'G9' ||  collectionObj.model === 'G10'){
            continue;
        }
        if (collectionObj.model.includes('R740')){
            hrefLink = 'dell-poweredge-r740' + '?target=' + collectionObj.model;
            liTag.addEventListener('mouseover', debouncePreload(() => preloadContentfulData(hrefLink.replace('-sbb','')), 400));

        }
        if (collectionObj.model.includes('R640')){
            hrefLink = 'dell-poweredge-r640' ;
            liTag.addEventListener('mouseover', debouncePreload(() => preloadContentfulData(hrefLink.replace('-sbb','')), 400));

        }
        if (collectionObj.model.includes('R730')){
            hrefLink = 'dell-poweredge-r730' + '?target=' + collectionObj.model;
            liTag.addEventListener('mouseover', debouncePreload(() => preloadContentfulData(hrefLink.replace('-sbb','')), 400));

        }
        if (collectionObj.model === '7910'){
            hrefLink = 'dell-poweredge-r730?version=DELL_PRECISION_7910_8B_SFF';
        }
        setHtmlAttr(liTag, 'id', collectionObj.model); // setAttr(liTag, id)
        setHtmlAttr(liTag, 'class', 'navbar_product_model'); // setAttr(liTag, id)
        setHtmlAttr(anchorTag, 'href', `/collections/${hrefLink}`); // setAttr(anchorTag, href)
        anchorTag.innerHTML = collectionObj.model; 
        if (collectionObj.numOfAvailProducts === 0) continue
        liTag.append(anchorTag); 
        ulTag.append(liTag); 
        
    }
}
// function renderServerProducts 



function _formatHyperLink(href) { // HELPER FN 
    /**
    @description: Hyperlinks are taken from `collection.href`, which are assigned as props during the props-attr assignment 
    mechanism that creates the objects in `categorizedCollections`
    @param  {string} href: href string taken from the collection which will be used to redirect usr to specific server model page 
    @return {string}
    **/
    let hrefCompArr = href.split('-'); 
    hrefCompArr.splice(2, 1); // rm generation identifier
    hrefCompArr.splice(2, 1); // rm generation identifier
    if (hrefCompArr[1] === '_') hrefCompArr.splice(1, 1) // rm '_' placeholder 
    return hrefCompArr.join('-'); 
}
// function _formatHyperLink 



function _skipCollection(keyWords, collectionTitle) { // HELPER FN 
    /**
    @description: Aux fn used in conjunction w fn `renderServerProducts` that skips a collection if matched with a collection name 2 skip 
    @param  {Array[string]}  keyWords: 
    @param  {string}         collection: 
    @return {boolean}
    **/
    for (const keyword of keyWords) {
        if (collectionTitle.includes(keyword)) return true 
    }
}
// function _skipCollection 



function setHref_2availGen(organizedGens, gen, anchorTag) {
    /**
    @description: When there aren't models to a gen, fn simply sets href to gen 
    @param  {Object[category, Array[Object]]} organizedGens: Categoriezed dataset
    **/
    let hrefLink = organizedGens[`${gen}`][0].href.toLowerCase(); 
    setHtmlAttr(anchorTag, 'href', `/collections/${hrefLink}`);
}
// function setHref_2availGen 



function orgIntoGen(collections, mods=[], keyWords=[]) {
    /**
    @description: collections are created in `nav_bar.assign_...` for each desired category. The collectionObj schema is:
    {
        model               : String, 
        href                : String, 
        title               : String, 
        numOfAvailProducts  : Number
    } 
    This fn groups colletionObjs into specific gen that is used for the sub-dropdown menu. The collectionObj.title
    contains important info that helps build the diff categories 
    @example titleCompArr: ['Dell', 'PowerEdge', '12th', 'Gen', 'R720'] 
    @param  {Array[Object]} collections: Arr of collection obj 
    @param  {Array[String]} mods: modifications that change the genName 
    @param  {Array[String]} keyWords: keywords within the collection obj's title that you wish to bypass 
    @return {Object[String, Array[Object]]} gensObj
    **/
    let gensObj = {}; 

    for (const collectionObj of collections) { 
        let titleCompArr    = collectionObj.title.split(' '), 
            genName  = titleCompArr.slice(1, 4).join(' ') // grabs serverType, genNum, generation, and model; see EX above
        ; 

        if (_skipCollection(keyWords, collectionObj.title.toLowerCase())) continue;
        if (genName[0] === '_') genName = genName.substring(2, genName.length); // rm placeholder `_` 
        if (genName[genName.length - 1] === '_') genName = genName.slice(0, -2); // rm placeholder `_` 
        if (mods.some(except => genName.includes(except))) genName = genName.split(' ').slice(1).join(' '); 

        if (gensObj[`${genName}`] === undefined) {
            gensObj[`${genName}`] = [collectionObj]; // init Arr[Obj]
        } else {
            gensObj[`${genName}`].push(collectionObj); // add 2 existing gen 
        }
    }
    return gensObj; // EX: {PowerEdge 14th Gen's: Arr[Obj], PowerEdge 13th Gen's: Arr[Obj], ...}
}
// function orgIntoGen 



function reOrgDellGens(organizedDellGens) {
    /**
    @description: fn creates copy of the param with some fields reordered. 
    Creates new name for keys and deletes old one. This fn is manual entry meaning that to change 
    the products dropdown menu, this fn is used to change and reorganize the dell collection 
    @param  {Object[String, Array[Object]]} organizedDellGens: 
    @return organizedDellGens
    **/
    const objectOrder = {
        "PowerEdge 15th Gen": null, 
        "PowerEdge 14th Gen": null, 
        "PowerEdge 13th Gen": null, 
        "PowerEdge 12th Gen": null, 
    }; 
    
    organizedDellGens = Object.assign(objectOrder, organizedDellGens); 
    organizedDellGens['PowerVaults']   = organizedDellGens["PowerVault"];
    organizedDellGens['Precisions']    = organizedDellGens["Precision"];
    organizedDellGens['XC Series']     = organizedDellGens["XC Serie"]; 
    organizedDellGens['VX Rails']      = organizedDellGens["VX Rail"];

    delete organizedDellGens["XC Serie"];
    delete organizedDellGens["Precision"];
    delete organizedDellGens["VX Rail"];
    delete organizedDellGens["PowerVault"];


    return organizedDellGens; 
}
// function reOrgDellGens 



function flattenHPgen(organizedHPgens) {
    /**
    @description: Specifically 4 HPs the organizedHPgens is an obj containing diff models within the same gen. 
    Ex: {ProLiant DL120 G9's: Arr[Obj], ProLiant DL160 G9's: Arr[Obj], ProLiant DL180 G9's: Arr[Obj], etc}
    This fn flattens the data so that there is only 1 gen, in this case 1 ProLiant G9 gen. 
    @param  {} organizedHPgens: 
    @return  flattenHpGen
    **/
    let flattenHpGen      = {}; 

    for (const [gen, models] of Object.entries(organizedHPgens)) {
        let genNameCompArr = gen.split(' '), // ['serverType', 'model', 'Gen']
            genTxt         = genNameCompArr[genNameCompArr.length - 1], // 'Gen'
            genName        = `${genNameCompArr[0]} ${genTxt}` // ex: proLiant G10
        ;  

        (flattenHpGen[genName] === undefined) ? flattenHpGen[genName] = [models[0]] : flattenHpGen[genName].push(models[0]);
    }

    return flattenHpGen; 
}
// function flattenHPgen 



function reOrgHPgens(organizedHPgens) {
    /**
    @description: curr 4 hp there is only 1 model inside models 
    @param {Object[String, Array[Object]]} organizedHPgens: 
    **/
    let flattenHpGen      = flattenHPgen(organizedHPgens), 
        hpGenOrder        = ["ProLiant G10", "ProLiant G9"], 
        reOrganizedHpGens = {}
    ; 

    hpGenOrder.forEach(function(gen) {
        if (flattenHpGen.hasOwnProperty(gen)) reOrganizedHpGens[gen] = flattenHpGen[gen]
    })

    return reOrganizedHpGens; 
}
// function reOrgHPgens 



function rmEmptyCat() {
    /**
    @description: fn checks if ul ending with the marker `ul[id$="-dropdown"]` has children el. If it does 
    not, e.i. the length of the children is 0, removes from the UI the ul tag with id `product_option...`
    from the DOM; defined in `nav_bar.products_dropdown_menu.liquid` 
    **/
    htmlEl('#productDropdownMenu').querySelectorAll('ul[id$="-dropdown"]').forEach(function(dropdown) {
        if (dropdown.children.length === 0) htmlEl(`#product_option_${dropdown.id}`).remove(); 
    })
}
// function rmEmptyCat



function screenDetection_4ProductsdropdownMenu() {
    /**
    @description: logic 2 toggles btw(mobile view, desktop view)
    **/
    if (window.innerWidth < 770) { // mobile view 
        enterMobileView_4navBarProducts(true); 
        htmlEl('.navbarProductsTab').querySelector('a').addEventListener('click', function () {
            const productsTabClosed = document.querySelector('.dropdown.navbarProductsTab.open');
            if (productsTabClosed) {
                htmlEl('#tech_talk_li_tag').style.marginTop = '0px'; 
                htmlEl('#DCRLI').style.marginTop = '0px';
            } else {
                //htmlEl('#tech_talk_li_tag').style.marginTop = '1375px'; 
                htmlEl('#DCRLI').style.marginTop = '1375px';
            //    addOthersCat(); 

            }
            
            // class='dropdown' but needs to be specific margin-top: 1200px; 
        })
    } else if (window.innerWidth >= 770) { // desktop view 
        enterMobileView_4navBarProducts(false); 


    } 
}
// function screenDetection_4ProductsdropdownMenu 



function brandDict() {
    /**
    @description: Creates a dict containing organized gens 4 each brand 
    @return dict 
    **/
    let dellMods                    = ['VXRAIL', 'Precision'], 
        dellBypassKWs               = ['servers', 'workstation', 'tower', 'desktops', 'Desktops', 'Laptops', 'laptops',], 
        HPbypassKWs                 = ['servers', 'tower'], 
        dict                        = {
            organizedDellGens           : orgIntoGen(dellServersOnShopify, dellMods, dellBypassKWs), 
            organizedHPgens             : orgIntoGen(hpServersOnShopify, [], HPbypassKWs), 
            organizedWorkstationGens    : orgIntoGen(workstationsOnShopify), 
            organizedCiscoGens          : orgIntoGen(ciscoCollections), 
            organizedDellTowerGens      : orgIntoGen(dellTowerCollections), 
            organizedHPtowerGens        : orgIntoGen(hpTowerCollections), 
            organizedSuperMicroGens     : orgIntoGen(superMicroCollections), 
        }
    ; 

    dict['reOrganizedDellGens'] = reOrgDellGens(dict.organizedDellGens) // Object[category: Array[Object]]
    dict['reOrganizedhpGens']   = reOrgHPgens(dict.organizedHPgens); 
    console.log("dict in brandDict:", dict);
    return dict; 
}
// function brandDict 



function enterMobileView_4navBarProducts(cond) {
    /**
    @description: 
    **/
    if (cond) { // mobile view 
        let dict = brandDict(); 
        createDiffGensOnUI(htmlEl('#dell-dropdown'),         true,  dict.reOrganizedDellGens,      true,  true); 
        createDiffGensOnUI(htmlEl('#hp-dropdown'),           true,  dict.reOrganizedhpGens,        false, true);
        createDiffGensOnUI(htmlEl('#WorkStations-dropdown'), true,  dict.organizedWorkstationGens, false, true);
        createDiffGensOnUI(htmlEl('#cisco-dropdown'),        false, dict.organizedCiscoGens,       false, true);
        createDiffGensOnUI(htmlEl('#dellTower-dropdown'),    false, dict.organizedDellTowerGens,   false, true);
        createDiffGensOnUI(htmlEl('#hpTower-dropdown'),      false, dict.organizedHPtowerGens,     false, true);
        createDiffGensOnUI(htmlEl('#superMicro-dropdown'),   false, dict.organizedSuperMicroGens,  false, true);
        rmEmptyCat();
        try{ 
        document.querySelector('.DCR').style.display = 'none';
        } catch (e) {
           // console.log(e);
        }

    } else { // desktop view 
        let dict = brandDict();  

        createDiffGensOnUI(htmlEl('#dell-dropdown'),         true,  dict.reOrganizedDellGens,      true); 
        createDiffGensOnUI(htmlEl('#hp-dropdown'),           true,  dict.reOrganizedhpGens,        false);
        createDiffGensOnUI(htmlEl('#WorkStations-dropdown'), true,  dict.organizedWorkstationGens, false);
        createDiffGensOnUI(htmlEl('#cisco-dropdown'),        false, dict.organizedCiscoGens,       false);
        createDiffGensOnUI(htmlEl('#dellTower-dropdown'),    false, dict.organizedDellTowerGens,   false);
        createDiffGensOnUI(htmlEl('#hpTower-dropdown'),      false, dict.organizedHPtowerGens,     false);
        createDiffGensOnUI(htmlEl('#superMicro-dropdown'),   false, dict.organizedSuperMicroGens,  false);
        rmEmptyCat(); 
        orderProductsByRank();
    }

}
// function enterMobileView_4navBarProducts 



function adjustProductDropdown_4bigScreens() {
    /**
    @description: 
    **/
    if (window.innerWidth > 900) {
        htmlEl('#productDropdownMenu').style.height = '655px'; 
        htmlEl('#productDropdownMenu').style.width  = '870px'; 
        htmlEl('#productDropdownMenu').style.left   = '5%'; 
        document.querySelectorAll('.otherProd').forEach(function (otherProd) {
            otherProd.setAttribute('style', 'font-size: 20px !important; padding: 5px 15px 5px 25px !important; line-height: 20px !important; transform: translateX(-10px);');
    });
    } else {
        htmlEl('#productDropdownMenu').style.height = '750px'; 
        htmlEl('#productDropdownMenu').style.width  = '110vw'; 
        htmlEl('#productDropdownMenu').style.left   = '-253%'; 
        document.querySelectorAll('.otherProd').forEach(function (otherProd) {
            otherProd.setAttribute('style', 'font-size: 16px !important; padding: 5px 15px 5px 25px !important; line-height: 20px !important; transform: translateX(-10px);');
    });
    }
}
// function adjustProductDropdown_4bigScreens 


function orderProductsByRank() {
    /**
    @description: 
    **/
    let dropdowns = document.querySelectorAll('.dropdown-submenu'); 

    dropdowns.forEach(function(liTag) {
        if (!liTag.id.includes('product_option')) { // focus on gen sections 
            let genTxtSection = liTag.querySelector('a span').innerText; 

            switch (genTxtSection) {

                case "PowerEdge 15th Gen":
                    let ulTag       = liTag.querySelector('ul'),
                        listItems   = Array.from(ulTag.getElementsByTagName('li'))
                    ; 

                    listItems.sort((a, b) => {
                        const dellPE_15GenModelRank = {
                            R950         : 13,
                            R850         : 12,
                            R750         : 11, 
                            R750xs       : 10,
                            R750xd       : 9, 
                            R750xd2      : 8, 
                            R650         : 7, 
                            R6625        : 6,  
                            'VxRail E560': 6, 
                            R550         : 4,
                            R450         : 4,
                            R350         : 3,
                            R250         : 2,
                            R150         : 1
                        }

                        return dellPE_15GenModelRank[b.id] - dellPE_15GenModelRank[a.id];
                    });

                    listItems.forEach(li => ulTag.appendChild(li)) // Re-append sorted list 2 ul
                    break;

                case "PowerEdge 14th Gen":
                    let ulTag1       = liTag.querySelector('ul'),
                        listItems1   = Array.from(ulTag1.getElementsByTagName('li'))
                    ; 

                    listItems1.sort((a, b) => {
                        const dellPE_14GenModelRank = {
                            R940         : 12,
                            R840         : 11,
                            R740         : 10, 
                            R740xd       : 9, 
                            R740xd2      : 8, 
                            R640         : 7, 
                            'VxRail E560': 6, 
                            R540         : 5,
                            R440         : 4,
                            R340         : 3,
                            R240         : 2,
                            R140         : 1
                        }

                        return dellPE_14GenModelRank[b.id] - dellPE_14GenModelRank[a.id];
                    });

                    listItems1.forEach(li => ulTag1.appendChild(li)) // Re-append sorted list 2 ul
                    break;
                case "PowerEdge 13th Gen": 
                    let ulTag2 = liTag.querySelector('ul'),
                        listItems2 = Array.from(ulTag2.getElementsByTagName('li'))
                    ; 
                    
                    listItems2.sort((a, b) => {
                        const dellPE_13GenModelRank = {
                            R930            : 10, 
                            R830            : 9,
                            R730            : 8, 
                            'Precision 7910': 7, 
                            R730xd          : 6, 
                            R630            : 5, 
                            XC630           : 4,
                            R430            : 3, 
                            R330            : 2,
                            R230            : 1,
                        }
                        
                        return dellPE_13GenModelRank[b.id] - dellPE_13GenModelRank[a.id];
                    });
                    
                    listItems2.forEach(li => ulTag2.appendChild(li));
                    break;
                case "PowerEdge 12th Gen": 
                    let ulTag3 = liTag.querySelector('ul'),
                        listItems3 = Array.from(ulTag3.getElementsByTagName('li'))
                    ; 
                    
                    listItems3.sort((a, b) => {
                        const dellPE_12GenModelRank = {
                            R820    : 5, 
                            R720    : 4, 
                            R720xd  : 3, 
                            DR4100  : 2, 
                            R520    : 1
                        }

                        return dellPE_12GenModelRank[b.id] - dellPE_12GenModelRank[a.id];
                    });

                    listItems3.forEach(li => ulTag3.appendChild(li));
                    break; 
                case "ProLiant G9": 

                    let ulTag4 = liTag.querySelector('ul'),
                        listItems4 = Array.from(ulTag4.getElementsByTagName('li'))
                    ; 

                    listItems4.sort((a, b) => {
                        const order = { 
                            DL380: 3,
                            DL360: 2,
                            DL160: 1,
                        }; 
                        
                        const aOrder = order[a.id] || 0;
                        const bOrder = order[b.id] || 0;
                    
                        return bOrder - aOrder;
                    });
                    

                    listItems4.forEach(li => ulTag4.appendChild(li));
                    break; 
                case "ProLiant G10": 
                    let ulTag5 = liTag.querySelector('ul'),
                        listItems5 = Array.from(ulTag5.getElementsByTagName('li'))
                    ; 

                    listItems5.sort((a, b) => {
                        const order = { 
                            DL560: 5,
                            DL380: 2,
                            DL360: 1 
                        }; 
                    
                        return order[b.id] - order[a.id];
                    });
                    

                    listItems5.forEach(li => ulTag5.appendChild(li));
                    break; 
                default:
                    break;
            }
        }

    })
}

async function checkStockAP(brand) {
    let url = new URL('https://apiapi.ombligo.com/GetNavStock');
    url.searchParams.append('brand', brand);

    return fetch(url, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        },
    })
    .then(response => response.json())
    .then(data => {
        return data;
    })
    .catch((error) => {
        console.error('Error:', error);
    });
}

async function pruneDellServersInNav(){
    let dellStock = await checkStockAP("Dell");
    dellStock = dellStock["Dell"];
    let dellUI = document.getElementById('product_option_dell-dropdown');
    let dellUISubModels = dellUI.querySelectorAll('.dropdown-submenu');
    let dellModels = dellUI.querySelectorAll('.navbar_product_model');


    dellModels.forEach(model => {
        let modelId = model.id;
        if (!dellStock.some(server => server.model === modelId)) {
            model.remove();
        }
    });

    dellUISubModels.forEach(subModel => {
        let modelsWithinSubModel = subModel.querySelectorAll('.navbar_product_model');
        if (modelsWithinSubModel.length === 0) {
            subModel.remove();
        }
    });
}


async function pruneHPserversInNav(){
    let Stock = await checkStockAP("HP");
    
    
    let UI = document.getElementById('product_option_hp-dropdown');
    
    let UISubModels = UI.querySelectorAll('.dropdown-submenu');

    let Models;

    UISubModels.forEach(subModel => {

        let GenTitle = subModel.querySelector('.product_gen_title_txt');
        if (GenTitle && GenTitle.innerText ){
            GenTitle = GenTitle.innerText;
        } else {
            let genName = subModel.querySelector('.dropdown-toggle span');
            if (genName) {
                GenTitle = genName.innerText;
            }
        }
        if (GenTitle ) {
            let key = GenTitle.split(' ').pop();

            currStock = Stock[key];

            
            Models = subModel.querySelectorAll('.navbar_product_model');

            Models.forEach(model => {
                let modelId = model.id;
                if (!currStock.some(server => server.model === modelId)) {
                    model.remove();
                }
            });

            UISubModels.forEach(subModel => {
                let modelsWithinSubModel = subModel.querySelectorAll('.navbar_product_model');
                if (modelsWithinSubModel.length === 0) {
                    subModel.remove();
                }
            });
        }

    });
    document.getElementById('hp_server_2').style.display = 'contents';

}

function renderSpecialOrderItems(containerId, organizedSpecialOrders) {
    const container = document.querySelector(containerId);
    if (!container) return;

    container.innerHTML = ''; 

    let gen_id_counter = 1;

    for (const [generation, models] of Object.entries(organizedSpecialOrders)) {
        const genLiTag = document.createElement('li');
        genLiTag.classList.add('dropdown-submenu');
        genLiTag.id = `specialOrders_gen_${gen_id_counter}_liGenMarker`; 
        
        const genAnchorTag = document.createElement('a');
        genAnchorTag.classList.add('dropdown-toggle', 'product_cat');
        genAnchorTag.href = `#`;
        
        const genLabelSpan = document.createElement('span');
        genLabelSpan.classList.add('nav-label', 'product_cat_lbl');
        genLabelSpan.style.color = 'rgb(121, 205, 205)';
        genLabelSpan.style.letterSpacing = '3px';
        genLabelSpan.style.fontWeight = '700';
        genLabelSpan.innerText = generation;

        genAnchorTag.append(genLabelSpan);
        genLiTag.append(genAnchorTag);

        const modelsContainerUl = document.createElement('ul');
        modelsContainerUl.classList.add('dropdown-menu', 'animate__animated', 'animate__fadeIn');
        modelsContainerUl.style.display = 'contents';
        modelsContainerUl.id = `specialOrders_server_${gen_id_counter}`; 

        models.forEach(orderItem => {
            const modelLiTag = document.createElement('li');
            modelLiTag.classList.add('navbar_product_model');
            modelLiTag.id = orderItem.handle.split('-').slice(-1)[0].toUpperCase(); 

            const modelAnchorTag = document.createElement('a');
            modelAnchorTag.href = `/collections/${orderItem.handle}`;
            modelAnchorTag.innerText = orderItem.handle.split('-').slice(-1)[0].toUpperCase(); 

            modelLiTag.append(modelAnchorTag);
            modelsContainerUl.append(modelLiTag);
        });

        genLiTag.append(modelsContainerUl);
        container.append(genLiTag);

        gen_id_counter += 1;
    }
}



function checkInventoryStatus() {
    const fetchPromises = specialOrderChecks.map((collection, index) => {
        return fetch(`/collections/${collection.handle}/products.json`)
            .then(response => response.json())
            .then(data => {
                let inStock = data.products.some(product => 
                    product.variants.some(variant => variant.available)
                );
                specialOrderChecks[index].stockStatus = inStock ? 1 : 0;

                if (!inStock) {
                    if (document.getElementById(specialOrderChecks[index].model)) {
                     document.getElementById(specialOrderChecks[index].model).remove();
                    }
                }
            })
            .catch(error => console.error('Error fetching inventory:', error));
    });

    Promise.all(fetchPromises).then(() => {
        const organizedSpecialOrders = orgIntoGen(
            specialOrderChecks.filter(orderItem => orderItem.stockStatus === 0)
        );
        renderSpecialOrderItems('#specialOrderSection', organizedSpecialOrders);

    });
}

document.addEventListener("DOMContentLoaded", () => {
    checkInventoryStatus();
    pruneDellServersInNav();
    pruneHPserversInNav();
});




screenDetection_4ProductsdropdownMenu(); 
adjustProductDropdown_4bigScreens(); 
window.addEventListener('resize', adjustProductDropdown_4bigScreens);
  

 